import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { RemovableContactLabel } from "components/Removables/RemovableContact";
import { useOpenNewContactSidePanel } from "components/SidePanel/contact/NewContactSidePanel";
import React from "react";
import { ModalPickerProps } from "../props";
import ContactList from "./ContactList";
import { AfterCreateAction } from "components/SidePanel/types";

type Props = Omit<ModalPickerProps<server.dto.ContactSmallV2>, "canCreateNew"> & {
  title?: string;
  initialKeyword?: string;
  excludeKeys?: number[];
  buttonLabel?: string;
  onModalClose?: () => void;
  fromCompanyId?: number;
} & (
    | { canCreateNew: false; afterCreate?: AfterCreateAction }
    | { canCreateNew: boolean; afterCreate: AfterCreateAction }
  );

const ContactModalPicker = (props: Props) => {
  const openNewContactSidePanel = useOpenNewContactSidePanel();
  const onChange = (value: server.dto.ContactSmallV2) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <>
    <ModalPickerWithChooseButton
      onModalClose={props.onModalClose}
      onNewClicked={() => openNewContactSidePanel({ onCreated: (contact) => onChange(contact), afterCreate: props.afterCreate ?? "closeSidebar" })}
      buttonLabel={props.buttonLabel ?? RESX.Buttons.btnSelect}
      modalTitle={props.title ?? RESX.Contact.Contacts}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ContactList
        fromCompanyId={props.fromCompanyId}
        initialKeyword={props.initialKeyword}
        excludeKeys={props.excludeKeys}
        onItemSelected={(contact) => {
          closeModal();
          onChange(contact);
        }}
      />}
      renderRemovable={(props) => <RemovableContactLabel {...props} />}

      {...props}
    />
  </>
};

export default ContactModalPicker;